module.exports = __webpack_public_path__ + "static/media/zipDownloadIcon.78632399.svg";